import { faHourglassClock } from '@fortawesome/pro-regular-svg-icons';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import AddProjectDomainDialog from '../../components/muiLegacy/Dialogs/AddDomainDialog/AddProjectDomainDialog';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import { DomainTypeGq } from '../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../graphql/projects/projectsApiService';
import { CurrentUserGq } from '../../graphql/users/models/CurrentUserGq';
import ProjectAppBar from '../ProjectPage/ProjectAppBar/ProjectAppBar';
import { ProjectTabChoices } from '../ProjectPage/ProjectPage';

export interface MissingRankDomainOrScrapePageProps {
  project: ProjectGq;
  user: CurrentUserGq;
  reload: () => Promise<unknown>;
  noDomain?: boolean;
  noRankData?: boolean;
  unfinishedScrape?: number;
  hasNoScrape?: boolean;
}

const MissingRankDomainOrScrapePage: React.FC<MissingRankDomainOrScrapePageProps> = ({
  project,
  reload,
  user,
  noDomain,
  noRankData,
  unfinishedScrape,
  hasNoScrape,
}) => {
  // Add domain
  const [addDomainOpen, setAddDomainOpen] = useState<DomainTypeGq | null>(null);
  const history = useHistory();

  // Trigger scrape
  const triggerScrapeMutation = projectsApiService.mutations.scraping.createScrapeUrls();
  const [scrapeLoading, setScrapeLoading] = useState(false);
  const handleCreateScrapeUrls = () => {
    setScrapeLoading(true);
    triggerScrapeMutation({ projectId: project.id })
      .then(reload)
      .finally(() => setScrapeLoading(false));
  };

  return (
    <>
      <ProjectAppBar project={project} user={user} />
      <VoxelPageContainer>
        <div className="mt-24 mx-auto max-w-3xl flex flex-col justify-center items-center gap-6">
          {noDomain && (
            <VoxelAlert
              severity='info'
              onClickTitle='Add domain'
              onClick={() => setAddDomainOpen(DomainTypeGq.PROJECT)}
            >
              The content plan feature requires that you have added a project domain
            </VoxelAlert>
          )}
          {noRankData && (
            <VoxelAlert
              severity='info'
              onClickTitle='Add rank data'
              onClick={() => history.push(`/${project.id}/${ProjectTabChoices.Manage}/fetchRankData`)}
            >
              The content plan feature requires that you have added rank data
            </VoxelAlert>
          )}
          {!!hasNoScrape && !project.scrapeCopyInProgress && !(noDomain || noRankData) && (
            <VoxelAlert
              severity='info'
              onClickTitle='Trigger scraping'
              onClick={handleCreateScrapeUrls}
            >
              The content plan feature requires scraping ranking urls
            </VoxelAlert>
          )}
          {!!unfinishedScrape && (
            <VoxelAlert title='' severity='info' fontAIconName={faHourglassClock}>
              <span className='flex flex-row items-center justify-between'>
                {'Unfinsihed scraping: ' + unfinishedScrape + ' ranking urls left'}
              </span>
            </VoxelAlert>
          )}
        </div>
      </VoxelPageContainer>
      {addDomainOpen !== null && addDomainOpen === DomainTypeGq.PROJECT && (
        <AddProjectDomainDialog
          project={project}
          onSuccess={(domainId) =>
            reload().then(() => {
              setAddDomainOpen(null);
            })
          }
          close={() => {
            setAddDomainOpen(null);
          }}
        />
      )}
    </>
  );
};

export default MissingRankDomainOrScrapePage;
